import { getLrwRoutes } from './lrwRoutes';
import { getSpeakingRoutes } from './speakingRoutes';
import { getExamDatesForLocationsRoutes } from './examDatesForLocationsRoutes';
import { getTestCentreOverviewRoutes } from './testCentreOverviewRoutes';

export const ROUTING_PATHS = {
  dashboard: '/',
  loginCallback: '/login-successful',
  ...getSpeakingRoutes('/speaking-sessions'),
  ...getLrwRoutes('/lrw-sessions'),
  ...getExamDatesForLocationsRoutes('/exam-dates-for-locations'),
  ...getTestCentreOverviewRoutes('/test-centre-overview'),
};

export * from './types';
